/* eslint-disable max-len */
import React from 'react';
import {IconProps} from './types';

export const VipIconSVG: React.FC<IconProps> = ({ isWithBorder }) => {
  return (
    <svg width="42" height="42">
      <g fill="none" fillRule="evenodd">
        {isWithBorder && (
          <path
            d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
            fill="#CCCBCB"
            fillRule="nonzero"
          />
        )}

        <path
          d="M37 12.388A3.389 3.389 0 0 0 33.61 9H8.39A3.389 3.389 0 0 0 5 12.388v17.225A3.389 3.389 0 0 0 8.39 33h25.22A3.389 3.389 0 0 0 37 29.613V12.388Z"
          fill="#D25352"
        />
        <g fill="#FEFEFE" fillRule="nonzero">
          <path d="M8.057 15h2.702l2.628 9.19L16.04 15h2.628l-4.131 12.106h-2.39zM19.974 15h2.513v12.106h-2.513zM29.986 22.753h-2.571v4.353h-2.513V15h5.272c1.216 0 2.185.312 2.908.936.723.624 1.084 1.59 1.084 2.9 0 1.428-.361 2.439-1.084 3.03-.723.591-1.755.887-3.096.887Zm1.182-2.521c.329-.29.493-.75.493-1.38 0-.63-.166-1.079-.497-1.347-.331-.268-.795-.402-1.392-.402h-2.357v3.564h2.357c.597 0 1.062-.145 1.396-.435Z" />
        </g>
      </g>
    </svg>
  );
};
